// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"zF-z","smallCardRow":"AF-z","largeCardRow":"BF-z","productSearchRow":"CF-z","curatedRow":"DF-z"};